import React from 'react'
import { useSnapshot } from 'valtio'
import { state } from '../../../context/store'
import { Button, Text, Row, Column, Spacer } from '../../Blocks';

const ModalCameraOptions = ({ id }) => {
    const snap = useSnapshot(state)

    const closePopup = () => {
        state.current.modal.cameraControls = false
        state.current.modal.open = false

    }
    const resetCamera = () => {
        state.current.cameraControls.position = [3.5, 1, 1]
        state.current.cameraControls.target = [0, 0, 0]
        state.current.modal.cameraControls = false
    }

    const autoCamOn = () => {
        state.current.autoCamera = true
    }
    const autoCamOff = () => {
        state.current.autoCamera = false
    }
    return (
        <Column id={id}>

            <Text>Auto Camera Settings?</Text>

            <Row justify="center" padding="8px">
                <Button selected={snap.autoCamera === false} handleClick={autoCamOff}>Autocam Off</Button>
                <Button selected={snap.autoCamera === true} handleClick={autoCamOn}>Autocam On</Button>
                <Spacer height="6px" />
            </Row>
            <Text minH="45px" size='14px'>{snap.autoCamera ? "The camera will automatically look at the area you are customising" : "The camera won't move automatically "}</Text>

            <Text>Reset Camera Position?</Text>
            <Row justify="center" padding="8px">
                <Button handleClick={closePopup}>Go back</Button>
                <Button handleClick={resetCamera}>Reset Camera</Button>
                <Spacer />
            </Row>
        </Column>


    )
}



export default ModalCameraOptions